import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45a176ba&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=45a176ba&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=45a176ba&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a176ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45a176ba')) {
      api.createRecord('45a176ba', component.options)
    } else {
      api.reload('45a176ba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45a176ba&scoped=true", function () {
      api.rerender('45a176ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/components/ColorPicker/index.vue"
export default component.exports